<template>
	<div class="website-preview">
		<header :style="{background:data.theme_color}">
			<img :src="`${cdnUrl}/static/images/avator.png`" alt="" v-if="data.logo">
			<h1 :style="{color: data.theme_font_color}" v-else>在线咨询</h1>
		</header>
		<main>
			<p class="welcome-mg" :style="{color: data.text_inverse_color}" v-show="data.default_welocme">{{data.default_welocme}}</p>
			<p class="private-msg" v-show="data.is_has_private_policy || data.is_has_service_policy">
				 <el-checkbox></el-checkbox>
				 <span :style="{color: data.text_inverse_color}">我已阅读并接受品牌 
					 <a v-show="data.is_has_private_policy" href="javascript:;" :style="{color: data.theme_color}">隐私声明</a>
					 <span v-show="data.is_has_service_policy && data.is_has_private_policy">与</span> <a :style="{color: data.theme_color}" href="javascript:;" v-show="data.is_has_service_policy">服务条款</a>
				 </span>
			</p>
			<div class="msg msg-left" :style="{color: data.text_inverse_color}">
				<img :src="data.agent_avator ? data.agent_avator : `${cdnUrl}/static/images/avator.png`" alt="">
				<div>
					<time>01-11 17:20:47</time>
					<p>坐席话术坐席话术坐席话术坐席话术坐席话术坐席话术坐席话术</p>
				</div>
			</div>
			<div class="msg msg-right" :style="{color: data.text_inverse_color}">
				<div>
					<time>01-11 17:20:47</time>
					<p>客人话术客人话术客人话术客客人话术客人话术客人话术客客人话术客人话术客人话术客</p>
				</div>
			</div>
		</main>
		<footer>
			<div class="editor-box">
				<ul class="tools">
					<li>
						<svg-icon icon-class="im-upload-img"></svg-icon>
					</li>
				</ul>
				<div class="sendbox">
					<p :style="{color: data.text_inverse_color}">请输入您的问题…</p>
				</div>
				<div class="sendbtn">
					<el-button type="primary" size="small" :style="{background:data.theme_color,color: data.theme_font_color}">发 送</el-button>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
	export default {
		props:['data'],
		data() {
			return {
				cdnUrl: process.env.VUE_APP_BASE_CDN,
				title: 'value'
			}
		},
	}
</script>

<style lang="scss" scoped>
	.website-preview {
		margin-top: 50px;
		width: 320px;
		height: 568px;
		background-color: #fff;
		box-shadow: 0px 4px 15px 0px rgba(169, 169, 169, 0.5);
		border-radius: 5px;
		position: relative;
		padding-bottom: 10px;
		header {
			width: 100%;
			height: 44px;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 0 15px;
			position: relative;
			h1 {
				font-size: 16px;
				font-weight: normal;
			}
			img {
				height: 30px;
				object-fit: contain;
				display: block;
			}
		}
		main {
			height: calc(100% - 132px - 44px - 10px);
			margin-bottom: 10px;
			position: relative;
			padding: 0 15px;
			overflow: auto;
			font-size: 12px;
			.welcome-mg {
				padding: 6px 7px;
				background: #F6F7F9;
				border-radius: 3px;
				line-height: 22px;
				margin: 10px 0;
				text-align: center;
				word-break: break-all;
			}
			.private-msg {
				display: flex;
				align-items: center;
				margin: 16px 0;
				a {
					text-decoration: underline;
				}
				span {
					margin-left: 6px;
				}
			}
			.msg {
				display: flex;
				align-items: flex-start;
				margin: 16px 0;
				p {
					padding: 4px 11px;
					border-radius: 4px;
					margin-top: 5px;
					max-width: 200px;
					line-height: 24px;
					
				}
				img {
					width: 32px;
					height: 32px;
					object-fit: cover;
					object-position: center;
					display: block;
					border-radius: 50%;
					
				}
				&.div {
					display: flex;
					flex-direction: column;
				}
			}
			.msg-left {
				p {
					background-color: #F6F7F9;
				}
				> img {
					margin-right: 8px;
				}
				time {
					text-align: left;
				}
			}
			.msg-right {
				p{
					background-color: #EDF5FF;
				}
				flex-direction: row-reverse;
				> img {
					display: none;
				}
				time {
					width: 100%;
					display: block;
					text-align: right;
				}
			}
		}
		footer {
			height: 132px;
			padding: 0 10px;
			.editor-box {
				height: 100%;
				border-radius: 3px;
				border: 1px solid #D8D8D8;
				padding: 0 12px;
				box-sizing: border-box;
				.tools {
					display: flex;
					align-items: center;
					padding-top: 10px;
					li {
						list-style: none;
					}
					.svg-icon {
						font-size: 24px;
					}
				}
				.sendbox {
					margin-top: 12px;
					height: calc(100% - 30px - 36px - 12px - 8px);
					p{
						height: 100%;
						margin: 0;
						font-size: 14px;
						line-height: 20px;
						border: none;
					}
				}
				.sendbtn {
					display: flex;
					align-items: center;
					justify-content: flex-end;
					::v-deep .el-button--small {
						height: 36px;
						width: 100px;
						border: none;
					}
				}
			}
		}
	
	}
</style>
